import React from 'react';
import VendorCard from '../../../components/ui/VendorCard';

const TrendingSection = ({ vendors, onVendorClick }) => {
    return (
        <section className="py-6 md:py-8 lg:py-10">
            <div className="flex items-center justify-between mb-4 md:mb-6">
                <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
                    Trending Vendors
                </h2>
                <span className="text-sm md:text-base text-muted-foreground font-caption">
                    {vendors?.length} vendors
                </span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
                {vendors?.map((vendor) => (
                    <VendorCard
                        key={vendor?.id}
                        vendor={vendor}
                        onClick={onVendorClick}
                    />
                ))}
            </div>
        </section>
    );
};

export default TrendingSection;